var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_vm._v(" Proszę czekać... Przełączam kontekst użytkownika... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }